import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { PharmacyStatus } from './models/PharmacyStatus';

export const PharmacyStatusStore = types
  .compose(
    getBaseStore<Instance<typeof PharmacyStatus>, Instance<typeof PharmacyStatus>>(
      PharmacyStatus,
      'pharmacyStatusId',
      'pharmacyStatus',
    ),
    types.model('PharmacyStatusStore', {}),
  )
  .actions((self) => {
    return {
      afterAttach: flow(function*() {
        yield self.loadList();
      }),
    };
  });

export type PharmacyStatusStoreType = Instance<typeof PharmacyStatusStore>;
